import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import moment from "moment";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import Chip from "@mui/material/Chip";
import LinearProgress from "@mui/material/LinearProgress";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { planActions } from "variables/planActions";
import { reclevelData } from "variables/lists/planActions";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import EditScenarioDialog from "./EditScenarioDialog";
import UserService from "services/UserService";
import {
  deleteActionPlanScenario,
  getActionPlan,
  getActionPlanScenario,
  putActionPlanScenario,
} from "services/ConfigServices";
import { ActionPlansContext } from "context/ActionPlansContext";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import useScenarioTable from "./useScenarioTable.js";

//import "react-table/react-table.css";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.7px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ExpandableComponent = ({ data, energy, parameters }) => {
  return (
    <Container>
      <ExpandableContainer>
        <div>
          <ExpandableElement>
            <ElementTitle>{planActions.scenarios.code} :</ElementTitle>
            <ElementData>{data?.parameters?.code}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{planActions.scenarios.description} :</ElementTitle>
            <ElementData>{data?.parameters?.description}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{planActions.scenarios.feasibility} :</ElementTitle>
            <ElementData>{data?.parameters?.feasibility}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{planActions.scenarios.grade} :</ElementTitle>
            <ElementData>{data?.parameters?.grade}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{planActions.scenarios.comments} :</ElementTitle>
            <ElementData>{data?.parameters?.comments}</ElementData>
          </ExpandableElement>

          <ExpandableElement>
            <ElementTitle>{"Actions associées"} : </ElementTitle>
            {data?.parameters?.associatedActions?.map((action) => {
              return <Chip label={action.fileName} key={action.fileId} />;
            }) || ""}
          </ExpandableElement>
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const RTScenarios = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const { gridState, refreshTable, refetch } = useScenarioTable();

  const [open, setOpen] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  const [selectedScenario, setSelectedScenario] = useState({});
  const [selectedScenarioId, setSelectedScenarioId] = useState();
  const [selectedRows, setSelectedRows] = useState(false);

  console.log("selectedRows", selectedRows);

  const [redirState, setRedirState] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  let redirecting = redirState ? (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/selectedaction/",
        state: { planActionId, planActionName, id, name },
      }}
    />
  ) : (
    ""
  );

  let dataScenarios = actionPlans.scenarios;

  console.log(dataScenarios);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: '16px',
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: '8px',
    },
  }))(MuiDialogActions);

  const classes = useStyles();

  console.log(gridState);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  function associatedActionsLength(actions) {
    return actions.length;
  }

  const columns = [
    {
      name: "Ordre de priorité",
      selector: (row) => row.parameters.order,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      name: "Nom",
      selector: (row) => row.parameters.name,
      sortable: true,
    },
    {
      name: "Nombre d'actions",
      sortable: true,
      maxWidth: "9rem",
      cell: (row) => <div> {row.parameters?.associatedActions?.length}</div>,
    },
    {
      name: "Niveau de recommandation",
      sortable: true,
      cell: (row) =>
        row.parameters.reclevel == "high" ? (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}>
            {reclevelData.find((x) => x.id == "high").name}
          </div>
        ) : row.parameters.reclevel == "medium" ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>
            {reclevelData.find((x) => x.id == "medium").name}
          </div>
        ) : row.parameters.reclevel == "low" ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>
            {reclevelData.find((x) => x.id == "low").name}
          </div>
        ) : (
          <div></div>
        ),
    },
    {
      name: "Date d'activation",
      sortable: true,
      maxWidth: "9rem",
      cell: (row) =>
        moment(row.parameters.activationdate).isValid()
          ? moment(row.parameters.activationdate).format("DD/MM/YYYY")
          : "",
    },
    actionplanadmin && {
      name: "Activation",
      sortable: true,
      width: "7rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <div style={{ margin: "-1.3rem 0rem -1.3rem -1rem" }}>
          <CustomSwitch
            checkedState={row.parameters?.active}
            handleSwitchChange={handleActivationSwitch(row)}
          />
        </div>
      ),
    },
    actionplanadmin && {
      name: "",
      sortable: false,
      width: "9rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editScenario(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression scenario"}
              deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le scénario ${row.parameters.name}?`}
              handleSupprimer={deleteScenario(row)}
            />
          </div>
        </>
      ),
    },
  ];

  const editScenario = (row) => async () => {
    let obj = dataScenarios.find((o) => o.id === row.id);
    console.log(obj);
    let idSelected = obj.id;
    console.log(idSelected);
    setSelectedScenarioId(obj.id);

    let url = getActionPlanScenario(idSelected);

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        console.log(res);
        setSelectedScenario(res.data.parameters);
      });

    handleClickOpen();
  };

  const deleteScenario = (row) => async () => {
    let obj = dataScenarios.find((o) => o.id === row.id);
    console.log(obj);
    let idSelected = obj.id;
    console.log(idSelected);
    let url = deleteActionPlanScenario(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success(
            `Le scénario ${obj.parameters.name} a été supprimé`
          );
        else NotificationManager.error("Un problème est survenu");
      });

    axios
      .get(getActionPlan(planActionId), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response);
        setActionPlans(response.data || []);
        refreshTable();
      });
  };

  const handleActivationSwitch = (row) => async () => {
    let obj = dataScenarios.find((o) => o.id === row.id);
    let idSelected = obj.id;

    let isActive = obj.parameters.active;

    let activeScenarioID;

    let isAnyActiveScenario = dataScenarios.findIndex(
      (x) => x.parameters.active === true
    );

    function getActivationDate() {
      if (isActive) {
        return "";
      } else {
        return moment().format("YYYY-MM-DD");
      }
    }

    let urlToActive = putActionPlanScenario(idSelected);

    await axios
      .put(
        urlToActive,
        {
          ...obj.parameters,
          active: !isActive,
          activationdate: getActivationDate(),
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("Le scénario a bien été modifié");
        else NotificationManager.error("Un problème est survenu");
      });

    if (isAnyActiveScenario !== -1) {
      console.log("exectued activescenario");
      activeScenarioID = dataScenarios.find((x) => x.parameters.active === true)
        .id;

      console.log(activeScenarioID);
      let urlIsActive = putActionPlanScenario(activeScenarioID);

      await axios
        .put(
          urlIsActive,
          {
            ...obj.parameters,
            active: false,
            activationdate: "",
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {});
    }

    await axios
      .get(getActionPlan(planActionId), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response);
        setActionPlans(response.data || []);
        refreshTable();
      });
  };

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader
        columns={columns}
        persistTableHead
        pagination
        subHeader
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        dense
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth={true}
        maxWidth="lg"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Modifier le scénario
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditScenarioDialog
            closeModal={handleClose}
            selectedScenario={selectedScenario}
            selectedScenarioId={selectedScenarioId}
            //setLoading={setLoading}
            //setNotification={setNotification}
            //refetch={refreshTable}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <NotificationContainer />
      {redirecting}
    </>
  );
};

export default RTScenarios;
